import { get } from "@utils/axios";

export const getFilterReq = (payload) => {
  return get(`filters?${localStorage.getItem('company_id') ? localStorage.getItem('company_id') : 1}&fields=page=1&filters=supporting_fields_|chart_type;preset_|organization_chart;`)
}

export const getFilterDataReq = (payload) => {
  return get(`companies/getOrganizationHierarchy?page=1&filters=chart_type_|` + payload)
}
export const getDataByIdTypeReq = (payload) => {
  return get(`companies/getSubordinates/${payload.id}?page=1&filters=chart_type_|` + payload.chartType)
}

export const getHrmsHierarchyReq = () => {
  return get(`companies/getHrmsHierarchy?page=1`)
}

export const getHrmsHierarchyNodeReq = (payload) => {
  return get(`companies/getHrmsHierarchyNode/${payload.type}/${payload.id}?page=1`)
}

export const getEmployeeHierarchyReq = () => {
  return get(`companies/getEmployeeReportingHierarchy?page=1`)
}

export const getEmployeeHierarchyChildrenReq = (payload) => {
  return get(`companies/getEmployeeReportingHierarchyChildren/${payload.id}?page=1`)
}
